import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBottomTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowBottomTop"><Path fillRule="evenodd" clipRule="evenodd" d="M16.7501 2.68945L21.8108 7.75011L20.7501 8.81077L17.5001 5.56077V21.0001H16.0001V5.56077L12.7501 8.81077L11.6895 7.75011L16.7501 2.68945ZM8.00011 3.00011V18.4395L11.2501 15.1895L12.3108 16.2501L7.25011 21.3108L2.18945 16.2501L3.25011 15.1895L6.50011 18.4395V3.00011H8.00011Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowBottomTop;
